import {
  ADD_COURSE_REVIEW_FAILURE,
  ADD_COURSE_REVIEW_REQUEST,
  ADD_COURSE_REVIEW_SUCCESS,
  ADD_INSTRUCTOR_REVIEW_FAILURE,
  ADD_INSTRUCTOR_REVIEW_REQUEST,
  ADD_INSTRUCTOR_REVIEW_SUCCESS,
  GET_COURSE_REVIEWS_FAILURE,
  GET_COURSE_REVIEWS_REQUEST,
  GET_COURSE_REVIEWS_SUCCESS,
  GET_INSTRUCTOR_REVIEWS_FAILURE,
  GET_INSTRUCTOR_REVIEWS_REQUEST,
  GET_INSTRUCTOR_REVIEWS_SUCCESS,
} from "./ActionType";

const initialState = {
  courseReviewResult: null,
  courseReviewIsLoading: false,
  courseReviewError: null,

  instructorReviewResult: null,
  instructorReviewIsLoading: false,
  instructorReviewError: null,

  instructorReviews: {},
  instructorReviewsIsLoading: false,
  instructorReviewsError: null,

  courseReviews: {},
  courseReviewsIsLoading: false,
  courseReviewsError: null,
};

export const reviewReducer = (state = initialState, action) => {
  switch (action.type) {
    case ADD_COURSE_REVIEW_REQUEST:
      return {
        ...state,
        courseReviewIsLoading: true,
        courseReviewError: null,
      };
    case ADD_COURSE_REVIEW_SUCCESS:
      return {
        ...state,
        courseReviewResult: action.payload,
        courseReviewIsLoading: false,
        courseReviewError: null,
      };
    case ADD_COURSE_REVIEW_FAILURE:
      return {
        ...state,
        courseReviewIsLoading: false,
        courseReviewError: action.payload,
      };
    case ADD_INSTRUCTOR_REVIEW_REQUEST:
      return {
        ...state,
        instructorReviewIsLoading: true,
        instructorReviewError: null,
      };
    case ADD_INSTRUCTOR_REVIEW_SUCCESS:
      return {
        ...state,
        instructorReviewResult: action.payload,
        instructorReviewIsLoading: false,
        instructorReviewError: null,
      };

    case ADD_INSTRUCTOR_REVIEW_FAILURE:
      return {
        ...state,
        instructorReviewIsLoading: false,
        instructorReviewError: action.payload,
      };
    case GET_INSTRUCTOR_REVIEWS_REQUEST:
      return {
        ...state,
        instructorReviewsIsLoading: true,
        instructorReviewsError: null,
      };
    case GET_INSTRUCTOR_REVIEWS_SUCCESS:
      return {
        ...state,
        instructorReviews: action.payload,
        instructorReviewsIsLoading: false,
        instructorReviewsError: null,
      };

    case GET_INSTRUCTOR_REVIEWS_FAILURE:
      return {
        ...state,
        instructorReviewsIsLoading: false,
        instructorReviewsError: action.payload,
      };
    case GET_COURSE_REVIEWS_REQUEST:
      return {
        ...state,
        courseReviewsIsLoading: true,
        courseReviewsError: null,
      };

    case GET_COURSE_REVIEWS_SUCCESS:
      return {
        ...state,
        courseReviews: action.payload,
        courseReviewsIsLoading: false,
        courseReviewsError: null,
      };

    case GET_COURSE_REVIEWS_FAILURE:
      return {
        ...state,
        courseReviewsIsLoading: false,
        courseReviewsError: action.payload,
      };
    default:
      return state;
  }
};
